__turbopack_context__.v({
  "activeSheetTab": "XLSViewer-module__2-7gAa__activeSheetTab",
  "sheetTab": "XLSViewer-module__2-7gAa__sheetTab",
  "sheetTabs": "XLSViewer-module__2-7gAa__sheetTabs",
  "spreadsheetContainer": "XLSViewer-module__2-7gAa__spreadsheetContainer",
  "xlsViewer": "XLSViewer-module__2-7gAa__xlsViewer",
});
